/* eslint-disable react/jsx-pascal-case */
// import { Col, Form, Input, Row, ColorPicker } from "antd";
import { Row, Col, Form, Input, ColorPicker } from './../../ui/ot'
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";

const NewsTypeForm = (
    {
        propsForm = null,
        field,
        formReloadCount = 0,
        onFormFinish = () => { },
        defaultValue
    }
) => {
    const [form] = Form.useForm();
    const [count, setCount] = useState(0);


    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }
    const setFieldValue = (name, value) => {
        if (propsForm) {
            propsForm.setValue(name, value);
        } else {
            form.setValue(name, value);
        }
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };
    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    // labelCol={{ span: 6 }}
                    // wrapperCol={{ span: 18 }}
                    // layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                // autoComplete="off"
                >

                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>


    )
}
const FormItemComponent = ({
    field,
    initialValues = {},
    getAnyFormValue,
    count,
    setFieldValue,
    setCount
}) => {
    return (
        <>
            <Row>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        name={[field?.name ?? '', 'news_type_id']}
                        fieldKey={[field?.fieldKey ?? '', 'news_type_id']}
                        initialValue={initialValues?.news_type_id}
                    >
                        <Input>
                        </Input>
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label={"分類名稱"}
                        name={[field?.name ?? '', 'news_type_name']}
                        fieldKey={[field?.fieldKey ?? '', 'news_type_name']}
                        initialValue={initialValues?.news_type_name}
                        rules={[
                            {
                                required: true,
                                message: "請輸入"
                            }
                        ]}
                    >
                        <Input>
                        </Input>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"背景顏色"}
                        name={[field?.name ?? '', 'background_color']}
                        fieldKey={[field?.fieldKey ?? '', 'background_color']}
                        initialValue={initialValues?.background_color}
                        rules={[
                            {
                                required: true,
                                message: "請輸入"
                            }
                        ]}
                    >
                        <ColorPicker
                            showText
                            format='hex'


                        />

                    </Form.Item>
                </Col>
                {/* <Col
                span={
                    24
                }
            >
                <Form.Item
                    labelCol={4}
                    wrapperCol={20}
                    {...field}
                    name={[field?.name ?? '', 'question_and_answer_id']}
                    fieldKey={[field?.fieldKey ?? '', 'question_and_answer_id']}
                    label="question_and_answer_id"
                    initialValue={initialValues?.name}
                    hidden={true}
                >
                    <div ></div>
                </Form.Item>
            </Col>
            <Col
                span={24}
            >
                <Form.Item
                    labelCol={4}
                    wrapperCol={20}
                    label="標題"
                    name={[field?.name ?? '', 'title']}
                    fieldKey={[field?.fieldKey ?? '', 'title']}
                    initialValue={initialValues?.title}
                    rules={[{ required: true, message: 'Please input name' }]}
                >
                    <Input />
                </Form.Item>
            </Col>
            */}
            </Row >
        </>
    );
};

export default NewsTypeForm;
